export class DaySelection {
    constructor(propertyName, prefixZero, callback = null, displayFields = {}, parseCallback = null, maxValue = 99) {
        this.propertyName = propertyName;
        this.prefixZero = prefixZero;
        this.callback = callback;
        this.displayFields = displayFields;
        this.parseCallback = parseCallback;
        this.maxValue = maxValue;
    }
    render(d) {
        let dayNumber = d[this.propertyName];
        if (null !== this.callback) {
            dayNumber = this.callback(dayNumber);
        }
        if (dayNumber === null || Number.isNaN(dayNumber) || dayNumber > this.maxValue) {
            return '-'.repeat(Math.log10(this.maxValue + 1));
        }
        if (this.prefixZero && dayNumber < 10) {
            return '0' + dayNumber;
        }
        return String(dayNumber);
    }
    parse(state) {
        if (!this.parseCallback) {
            return state;
        }
        return this.parseCallback(state);
    }
    get displayHours() {
        var _a;
        return (_a = this.displayFields.displayHours) !== null && _a !== void 0 ? _a : false;
    }
    get displayMinutes() {
        var _a;
        return (_a = this.displayFields.displayMinutes) !== null && _a !== void 0 ? _a : false;
    }
    get displaySeconds() {
        var _a;
        return (_a = this.displayFields.displaySeconds) !== null && _a !== void 0 ? _a : false;
    }
    get displayMilliseconds() {
        var _a;
        return (_a = this.displayFields.displayMilliseconds) !== null && _a !== void 0 ? _a : false;
    }
    get displayMicroseconds() {
        var _a;
        return (_a = this.displayFields.displayMicroseconds) !== null && _a !== void 0 ? _a : false;
    }
    get displayDate() {
        var _a;
        return (_a = this.displayFields.displayDate) !== null && _a !== void 0 ? _a : false;
    }
    get displayMonth() {
        var _a;
        return (_a = this.displayFields.displayMonth) !== null && _a !== void 0 ? _a : false;
    }
    get displayYear() {
        var _a;
        return (_a = this.displayFields.displayYear) !== null && _a !== void 0 ? _a : false;
    }
    get displayTimezone() {
        var _a;
        return (_a = this.displayFields.displayTimezone) !== null && _a !== void 0 ? _a : false;
    }
}
//# sourceMappingURL=DaySelection.js.map
